/**
 * The values that change without the prose changing. Bump VERSION only when the
 * substance changes — the version string is the consent record stored on
 * User.eula_version, so a cosmetic edit that bumps it would misrepresent what a
 * user agreed to.
 */
export const VERSION = 'v2.0';

// ponytail: hand-set, not build-stamped. Effective dates are a legal fact, not a
// deploy artifact — a rebuild must not silently re-date a published document.
export const EFFECTIVE_DATE = '2026-08-18';

export const ENTITY = '(주)아카에이아이';

/**
 * No CPO is separately designated, so 시행령 제32조 제2항 makes 대표자 the CPO by
 * default. 법 제30조 제1항 제5호 requires the 처리방침 to publish "성명 또는 …
 * 부서의 명칭과 연락처" — the alternation is why a department name and address
 * satisfy it without publishing an individual's name.
 */
export const CPO_ROLE = '대표이사';
export const CONTACT_DEPT = '개인정보보호 담당부서';
export const CONTACT_EMAIL = 'info@akaintelligence.com';
